export default {
  // ========== URINALYSIS ==========
  Color: { unit: "", referenceRange: "Yellow to amber / normal" },
  Appearance: {
    unit: "",
    referenceRange: "Clear to slightly cloudy / normal",
  },
  Odor: { unit: "", referenceRange: "Typical / none unusual" },
  Volume: {
    unit: "mL",
    referenceRange: "800 – 2000 mL / 24 hr (varies)",
  },
  pH: { unit: "", referenceRange: "4.5 – 8.0" },
  "Specific Gravity": { unit: "", referenceRange: "1.003 – 1.030" },

  Protein: { unit: "mg/dL", referenceRange: "0 – trace" },
  Glucose: { unit: "mg/dL", referenceRange: "0 (negative to trace)" },
  Ketones: { unit: "mg/dL", referenceRange: "0 (negative)" },
  Bilirubin: { unit: "mg/dL", referenceRange: "0 (negative)" },
  Urobilinogen: {
    unit: "mg/dL",
    referenceRange: "0.2 – 1.0 (Ehrlich units)",
  },
  Nitrite: { unit: "", referenceRange: "Negative" },
  "Leukocyte Esterase": { unit: "", referenceRange: "Negative" },
  Blood: { unit: "", referenceRange: "Negative" },

  "Microscopy - RBC": { unit: "/HPF", referenceRange: "0 – 2 RBC / HPF" },
  "Microscopy - WBC": { unit: "/HPF", referenceRange: "0 – 5 WBC / HPF" },
  "Epithelial Cells": { unit: "/HPF", referenceRange: "0 – few" },
  Bacteria: { unit: "", referenceRange: "None (or rare / occasional)" },
  Yeast: { unit: "", referenceRange: "None" },
  Casts: { unit: "", referenceRange: "None or rare hyaline" },
  Crystals: { unit: "", referenceRange: "None or occasional" },
  Spermatozoa: { unit: "", referenceRange: "None (in non-male urine)" },
  Parasites: { unit: "", referenceRange: "None" },

  // ========== STOOL ==========
  Consistency: { unit: "", referenceRange: "Soft, formed" },
  Quantity: {
    unit: "g",
    referenceRange: "Varies (approx. 100 – 300 g/day)",
  },
  Mucus: { unit: "", referenceRange: "Absent or minimal" },
  "Visible Blood": { unit: "", referenceRange: "Absent" },
  "Occult Blood": { unit: "", referenceRange: "Negative" },
  "Worms/Segments": { unit: "", referenceRange: "None" },
  "Ova/Parasites": { unit: "", referenceRange: "None" },
  Cysts: { unit: "", referenceRange: "None" },
  Trophozoites: { unit: "", referenceRange: "None" },
  "RBC in stool": { unit: "/HPF", referenceRange: "0 – 2 RBC / HPF" },
  "WBC in stool": { unit: "/HPF", referenceRange: "0 – 5 WBC / HPF" },
  "Fat globules": { unit: "", referenceRange: "None / minimal" },
  "Starch granules": { unit: "", referenceRange: "Absent or occasional" },
  "Undigested food particles": { unit: "", referenceRange: "Occasional" },
  Charcot_Leyden_Crystals: { unit: "", referenceRange: "None" },
  "Reducing Substances": { unit: "", referenceRange: "Negative" },
  Fat: { unit: "%", referenceRange: "< 7 % (approx)" },
  "Stool Culture": { unit: "", referenceRange: "No pathogenic growth" },
  "Salmonella spp.": { unit: "", referenceRange: "Absent" },
  "Shigella spp.": { unit: "", referenceRange: "Absent" },
  "E. coli (pathogenic strains)": {
    unit: "",
    referenceRange: "Absent or normal flora only",
  },
  "Vibrio cholerae": { unit: "", referenceRange: "Absent" },
  "Campylobacter spp.": { unit: "", referenceRange: "Absent" },
  "Clostridium difficile toxin": { unit: "", referenceRange: "Negative" },
  "Giardia lamblia antigen": { unit: "", referenceRange: "Negative" },
  "Entamoeba histolytica antigen": {
    unit: "",
    referenceRange: "Negative",
  },
  "Rotavirus antigen": { unit: "", referenceRange: "Negative" },
  "Adenovirus antigen": { unit: "", referenceRange: "Negative" },

  // ========== CBC / Hematology ==========
  Hemoglobin: {
    unit: "g/dL",
    referenceRange: "13.5 – 17.5 (M); 12.0 – 16.0 (F)",
  }, // :contentReference[oaicite:0]{index=0}
  Hematocrit: { unit: "%", referenceRange: "41 – 53 (M); 36 – 46 (F)" }, // :contentReference[oaicite:1]{index=1}
  "RBC Count": {
    unit: "x10^12/L",
    referenceRange: "4.3 – 5.9 (M); 3.5 – 5.5 (F)",
  }, // :contentReference[oaicite:2]{index=2}
  "WBC Count": { unit: "x10^9/L", referenceRange: "4.5 – 11.0" }, // :contentReference[oaicite:3]{index=3}
  Platelets: { unit: "x10^9/L", referenceRange: "150 – 400" }, // :contentReference[oaicite:4]{index=4}

  MCV: { unit: "fL", referenceRange: "80 – 100" }, // :contentReference[oaicite:5]{index=5}
  MCH: { unit: "pg", referenceRange: "27 – 31" }, // :contentReference[oaicite:6]{index=6}
  MCHC: { unit: "g/dL", referenceRange: "32 – 36" }, // :contentReference[oaicite:7]{index=7}
  RDW_CV: { unit: "%", referenceRange: "11.0 – 14.5" }, // :contentReference[oaicite:8]{index=8}
  RDW_SD: { unit: "fL", referenceRange: "??" },

  Neutrophils: { unit: "%", referenceRange: "50 – 70" }, // typical differential
  Lymphocytes: { unit: "%", referenceRange: "20 – 40" },
  Monocytes: { unit: "%", referenceRange: "2 – 8" },
  Eosinophils: { unit: "%", referenceRange: "1 – 4" },
  Basophils: { unit: "%", referenceRange: "0 – 1" },

  "Absolute Neutrophil Count": {
    unit: "x10^9/L",
    referenceRange: "2.0 – 7.5",
  },
  "Absolute Lymphocyte Count": {
    unit: "x10^9/L",
    referenceRange: "1.0 – 3.5",
  },
  "Absolute Monocyte Count": {
    unit: "x10^9/L",
    referenceRange: "0.2 – 0.8",
  },
  "Absolute Eosinophil Count": {
    unit: "x10^9/L",
    referenceRange: "0.02 – 0.5",
  },
  "Absolute Basophil Count": {
    unit: "x10^9/L",
    referenceRange: "0 – 0.1",
  },

  MPV: { unit: "fL", referenceRange: "7.5 – 11.5" },
  PDW: { unit: "%", referenceRange: "10 – 20" },
  PCT: { unit: "%", referenceRange: "0.19 – 0.39" },

  "Reticulocyte Count": { unit: "%", referenceRange: "0.5 – 2.0" },
  "Reticulocyte Hemoglobin": { unit: "pg", referenceRange: "??" },

  ESR: { unit: "mm/hr", referenceRange: "0 – 15 (M); 0 – 20 (F)" },
  "NRBC Count": { unit: "/100 WBCs", referenceRange: "0" },
  "Immature Granulocytes": { unit: "%", referenceRange: "0 – 1" },

  // ========== BIOCHEMISTRY / ELECTROLYTES ==========
  "Glucose (FBS)": { unit: "mg/dL", referenceRange: "70 – 100" }, // :contentReference[oaicite:9]{index=9}
  "Glucose (RBS)": {
    unit: "mg/dL",
    referenceRange: "< 140 (non-fasting)",
  },
  "Glucose (PPBS)": { unit: "mg/dL", referenceRange: "< 140" },
  HbA1c: { unit: "%", referenceRange: "4.0 – 5.9" },

  Urea: { unit: "mg/dL", referenceRange: "7 – 20" }, // BUN range :contentReference[oaicite:10]{index=10}
  Creatinine: { unit: "mg/dL", referenceRange: "0.6 – 1.2" }, // :contentReference[oaicite:11]{index=11}
  BUN: { unit: "mg/dL", referenceRange: "8 – 20" },
  "Uric Acid": { unit: "mg/dL", referenceRange: "3.0 – 8.2" }, // :contentReference[oaicite:12]{index=12}
  eGFR: {
    unit: "mL/min/1.73m²",
    referenceRange: "≥ 90 normal, 60–89 mild",
  },

  Sodium: { unit: "mmol/L", referenceRange: "136 – 146" }, // :contentReference[oaicite:13]{index=13}
  Potassium: { unit: "mmol/L", referenceRange: "3.5 – 5.0" }, // :contentReference[oaicite:14]{index=14}
  Chloride: { unit: "mmol/L", referenceRange: "95 – 105" }, // :contentReference[oaicite:15]{index=15}
  Bicarbonate: { unit: "mmol/L", referenceRange: "22 – 28" }, // :contentReference[oaicite:16]{index=16}
  Calcium: { unit: "mg/dL", referenceRange: "8.4 – 10.2" }, // :contentReference[oaicite:17]{index=17}
  Phosphorus: { unit: "mg/dL", referenceRange: "3.0 – 4.5" }, // :contentReference[oaicite:18]{index=18}
  Magnesium: { unit: "mg/dL", referenceRange: "1.5 – 2.0" }, // :contentReference[oaicite:19]{index=19}

  "AST (SGOT)": { unit: "U/L", referenceRange: "12 – 38" }, // :contentReference[oaicite:20]{index=20}
  "ALT (SGPT)": { unit: "U/L", referenceRange: "10 – 40" }, // :contentReference[oaicite:21]{index=21}
  "Alkaline Phosphatase": { unit: "U/L", referenceRange: "25 – 100" }, // :contentReference[oaicite:22]{index=22}
  GGT: { unit: "U/L", referenceRange: "9 – 48" }, // approximate / lab-dependent
  LDH: { unit: "U/L", referenceRange: "45 – 200" }, // :contentReference[oaicite:23]{index=23}

  "Total Protein": { unit: "g/dL", referenceRange: "6.0 – 7.8" }, // :contentReference[oaicite:24]{index=24}
  Albumin: { unit: "g/dL", referenceRange: "3.5 – 5.5" }, // :contentReference[oaicite:25]{index=25}
  Globulin: { unit: "g/dL", referenceRange: "2.3 – 3.5" }, // :contentReference[oaicite:26]{index=26}
  "A/G Ratio": { unit: "", referenceRange: "1.0 – 2.0" }, // typical

  "Total Bilirubin": { unit: "mg/dL", referenceRange: "0.1 – 1.0" }, // :contentReference[oaicite:27]{index=27}
  "Direct Bilirubin": { unit: "mg/dL", referenceRange: "0.0 – 0.3" }, // :contentReference[oaicite:28]{index=28}
  "Indirect Bilirubin": { unit: "mg/dL", referenceRange: "0.1 – 0.7" }, // derived

  Cholesterol: { unit: "mg/dL", referenceRange: "< 200" }, // :contentReference[oaicite:29]{index=29}
  Triglycerides: { unit: "mg/dL", referenceRange: "< 150" }, // :contentReference[oaicite:30]{index=30}
  HDL: { unit: "mg/dL", referenceRange: "40 – 60" }, // :contentReference[oaicite:31]{index=31}
  LDL: { unit: "mg/dL", referenceRange: "< 160" }, // :contentReference[oaicite:32]{index=32}
  VLDL: { unit: "mg/dL", referenceRange: "5 – 40" }, // approximate

  "LDL/HDL Ratio": { unit: "", referenceRange: "≤ 3.5" }, // typical guideline

  Amylase: { unit: "U/L", referenceRange: "25 – 125" }, // :contentReference[oaicite:33]{index=33}
  Lipase: { unit: "U/L", referenceRange: "13 – 60" }, // :contentReference[oaicite:34]{index=34}

  CK: { unit: "U/L", referenceRange: "25 – 90 (M); 10 – 70 (F)" }, // :contentReference[oaicite:35]{index=35}
  "CK-MB": { unit: "U/L", referenceRange: "< 5" }, // lab-dependent
  "Troponin I": { unit: "ng/mL", referenceRange: "≤ 0.04" }, // :contentReference[oaicite:36]{index=36}
  BNP: { unit: "pg/mL", referenceRange: "< 100" }, // guideline cutoff

  TSH: { unit: "µIU/mL", referenceRange: "0.4 – 4.0" }, // :contentReference[oaicite:37]{index=37}
  "Free T4": { unit: "ng/dL", referenceRange: "0.9 – 1.7" }, // :contentReference[oaicite:38]{index=38}
  "Free T3": { unit: "pg/mL", referenceRange: "2.3 – 4.2" }, // approximate

  CRP: { unit: "mg/L", referenceRange: "< 5" },
  Ferritin: {
    unit: "ng/mL",
    referenceRange: "20 – 250 (M); 10 – 120 (F)",
  }, // :contentReference[oaicite:39]{index=39}
  Iron: { unit: "µg/dL", referenceRange: "65 – 175 (M); 50 – 170 (F)" }, // :contentReference[oaicite:40]{index=40}
  TIBC: { unit: "µg/dL", referenceRange: "250 – 400" }, // :contentReference[oaicite:41]{index=41}
  "Transferrin Saturation": { unit: "%", referenceRange: "15 – 50" },
  "Vitamin B12": { unit: "pg/mL", referenceRange: "200 – 900" },
  "Vitamin D (25-OH)": { unit: "ng/mL", referenceRange: "20 – 50" },

  // ========== SEROLOGY / IMMUNOLOGY ==========
  "HIV 1/2 Antibody (Rapid Test)": {
    unit: "",
    referenceRange: "Negative",
  },
  "HIV 1/2 Ag/Ab Combo (p24 Antigen + Antibody)": {
    unit: "",
    referenceRange: "Negative",
  },
  "HIV 1 Antibody Confirmatory": { unit: "", referenceRange: "Negative" },
  "HIV 2 Antibody Confirmatory": { unit: "", referenceRange: "Negative" },
  "CD4 Count": { unit: "cells/µL", referenceRange: "500 – 1,500" },
  "HIV Viral Load (PCR)": {
    unit: "copies/mL",
    referenceRange: "Undetectable (i.e., < 20–50)",
  },

  "Hepatitis B Surface Antigen": { unit: "", referenceRange: "Negative" },
  "Hepatitis C Antibody": { unit: "", referenceRange: "Negative" },
  VDRL: { unit: "", referenceRange: "Non-reactive" },
  RF: { unit: "IU/mL", referenceRange: "< 20" },
  ASO: { unit: "IU/mL", referenceRange: "< 200" },
  "Troponin T": { unit: "ng/mL", referenceRange: "≤ 0.04" },
  "D-Dimer": { unit: "µg/mL", referenceRange: "< 0.5" },

  // ========== COAGULATION ==========
  PT: { unit: "sec", referenceRange: "11 – 15" },
  INR: { unit: "", referenceRange: "0.8 – 1.2" },
  aPTT: { unit: "sec", referenceRange: "25 – 40" },
  Fibrinogen: { unit: "mg/dL", referenceRange: "200 – 400" },
  "Thrombin Time": { unit: "sec", referenceRange: "14 – 20" },
  "Bleeding Time": { unit: "min", referenceRange: "2 – 7" },
  "Clotting Time": { unit: "min", referenceRange: "5 – 10" },
  "Antithrombin III": { unit: "%", referenceRange: "80 – 120" },
  "Protein C Activity": { unit: "%", referenceRange: "70 – 140" },
  "Protein S Activity": { unit: "%", referenceRange: "60 – 130" },

  // ========== HORMONES ==========
  T3: { unit: "ng/dL", referenceRange: "80 – 200" },
  T4: { unit: "µg/dL", referenceRange: "5 – 12" },

  Insulin: { unit: "µIU/mL", referenceRange: "2 – 25" },
  "C-Peptide": { unit: "ng/mL", referenceRange: "0.5 – 2.0" },

  Cortisol: { unit: "µg/dL", referenceRange: "5 – 23 (morning)" },
  ACTH: { unit: "pg/mL", referenceRange: "7 – 50" },

  Prolactin: { unit: "ng/mL", referenceRange: "2 – 18" },
  LH: {
    unit: "mIU/mL",
    referenceRange: "1.5 – 9.3 (M); 2 – 14 (F, varies by cycle)",
  },
  FSH: {
    unit: "mIU/mL",
    referenceRange: "1.5 – 12.4 (M); 3 – 20 (F, cycle-dependent)",
  },

  Testosterone: { unit: "ng/dL", referenceRange: "300 – 1,000 (M)" },
  "Free Testosterone": { unit: "pg/mL", referenceRange: "5 – 21 (M)" },
  DHEAS: { unit: "µg/dL", referenceRange: "35 – 430" },

  Estradiol: {
    unit: "pg/mL",
    referenceRange: "10 – 50 (M); 30 – 400 (F, cycle-dependent)",
  },
  Progesterone: {
    unit: "ng/mL",
    referenceRange: "0.1 – 1.5 (M); 0.2 – 25 (F, cycle-dependent)",
  },

  PTH: { unit: "pg/mL", referenceRange: "10 – 65" },
  Calcitonin: { unit: "pg/mL", referenceRange: "0 – 11" },

  GH: { unit: "ng/mL", referenceRange: "0 – 5 (basal)" },
  IGF_1: { unit: "ng/mL", referenceRange: "100 – 300 (age dependent)" },

  Aldosterone: { unit: "ng/dL", referenceRange: "4 – 31 (upright)" },
  Renin: { unit: "ng/mL/hr", referenceRange: "0.15 – 2.33" },

  Leptin: { unit: "ng/mL", referenceRange: "0.5 – 15" },
  Adiponectin: { unit: "µg/mL", referenceRange: "5 – 30" },

  // ========== MICROBIOLOGY / IMMUNOLOGY ==========
  "Gram Stain": {
    unit: "",
    referenceRange: "No organisms, normal flora only",
  },
  "Culture & Sensitivity": {
    unit: "",
    referenceRange: "No pathogenic growth",
  },
  "AFB Smear": { unit: "", referenceRange: "Negative" },
  "GeneXpert MTB/RIF": { unit: "", referenceRange: "Negative" },
  "Malaria Parasite (Smear)": { unit: "", referenceRange: "Negative" },
  "Malaria Parasite (RDT)": { unit: "", referenceRange: "Negative" },
  "Widal Test": {
    unit: "titer",
    referenceRange: "≤ 1:80 (depends on region)",
  },
  "Blood Culture": { unit: "", referenceRange: "No growth" },
  "Urine Culture": {
    unit: "",
    referenceRange: "No growth or < 10^5 cfu/mL",
  },
  "Sputum Culture": {
    unit: "",
    referenceRange: "No growth or non-pathogen flora",
  },

  ANA: { unit: "", referenceRange: "Negative" },
  "Anti-dsDNA": { unit: "", referenceRange: "Negative" },
  "Anti-Smith (Sm)": { unit: "", referenceRange: "Negative" },
  "Anti-RNP": { unit: "", referenceRange: "Negative" },
  "Anti-SSA (Ro)": { unit: "", referenceRange: "Negative" },
  "Anti-SSB (La)": { unit: "", referenceRange: "Negative" },
  "Anti-Scl-70": { unit: "", referenceRange: "Negative" },
  "Anti-Jo-1": { unit: "", referenceRange: "Negative" },
  "HLA-B27": { unit: "", referenceRange: "Negative" },

  "Rheumatoid Factor (RF)": { unit: "IU/mL", referenceRange: "< 20" },
  "Anti-CCP": { unit: "U/mL", referenceRange: "< 20" },

  C3: { unit: "mg/dL", referenceRange: "90 – 180" },
  C4: { unit: "mg/dL", referenceRange: "16 – 47" },

  IgG: { unit: "mg/dL", referenceRange: "700 – 1,600" },
  IgA: { unit: "mg/dL", referenceRange: "70 – 400" },
  IgM: { unit: "mg/dL", referenceRange: "40 – 230" },
  IgE: { unit: "IU/mL", referenceRange: "0 – 100" },

  // ========== OTHERS ==========
  PSA: { unit: "ng/mL", referenceRange: "0 – 4.0" },
  "Free PSA": {
    unit: "ng/mL",
    referenceRange: "0 – 0.8 (varies by lab)",
  },
  Vitamin_D: { unit: "ng/mL", referenceRange: "20 – 50" },
  Folate: { unit: "ng/mL", referenceRange: "3 – 20" },
  Transferrin: { unit: "mg/dL", referenceRange: "200 – 360" },

  CEA: { unit: "ng/mL", referenceRange: "< 5.0" },
  CA_125: { unit: "U/mL", referenceRange: "< 35" },
  CA_19_9: { unit: "U/mL", referenceRange: "< 37" },
  CA_15_3: { unit: "U/mL", referenceRange: "< 30" },
  AFP: { unit: "ng/mL", referenceRange: "< 10" },
  Beta_hCG: { unit: "mIU/mL", referenceRange: "< 5 (non-pregnant)" },

  Homocysteine: { unit: "µmol/L", referenceRange: "5 – 15" },
};
